import React, {FC, useEffect} from 'react';

import {dispatch} from 'store';
import {getStripePrices, setBillingType, setCurrentStripePrice, setRefreshToken} from 'modules/auth/actions';
import {getUserInfo} from 'modules/user/actions';

import {Button} from 'views/components';

import {history} from 'services/history';
import {getCurrencySymbol, useQuery} from 'utils';
import styles from './UpgradePlan.module.css';
import {t} from 'utils';
import texts from './texts';
import {useSelector} from "react-redux";
import {RootState} from "../../../types";
import { Api } from 'services/api';
import { privatePolicyLink, termsCondition } from 'config';

export const UpgradeOnlinePlan: FC = () => {
  const {userInfo, currencyType} = useSelector((state: RootState) => state.user);
  const {stripePrices} = useSelector((state: RootState) => state.auth);
  const refreshToken = useQuery().get('token' || '');
  const apiToken = Api.getAxios().defaults.headers.Authorization ? true : false;

  useEffect(() => {
    localStorage.clear();
  }, [])

  useEffect(() => {
    if (refreshToken) {
      dispatch(setRefreshToken(refreshToken));
      dispatch(getUserInfo.request());
    }
  }, [refreshToken]);

  useEffect(() => {
    if (currencyType && apiToken) {
      dispatch(getStripePrices.request());
    }
  }, [currencyType, apiToken]);

  const stripePricesMonthly: any = [];

  stripePrices.map(el => {
    if (el.billing_type === 'monthly') {
      stripePricesMonthly.push(el);
  }
});

//   const prices = stripePrices && stripePrices.filter(i => i.billing_type === 'monthly')
//   const pricePps = stripePrices && stripePrices.filter(i => i.billing_type === 'ppc')
// const oneCamera = prices && prices.find(i => i.nickname === '1 camera');
// const twoCameras = prices && prices.find(i => i.nickname === '2 cameras');
// const ppcPrice = pricePps && pricePps.find(i => i.nickname === '1 camera');
const currencySymbol = getCurrencySymbol(       
  stripePrices && 
  stripePrices.length &&
  stripePrices[0].currency ||'eur')

  return (
    <div className={styles.wrapper}>
      <div className={styles.wrap}>
          <div className={styles.header}>
            <span className={styles.headerTitle}>
              {/*TODO i18*/}
              {t(texts.upgradePlan.title)}
            </span>
            <p className={styles.headerSub}>{t(texts.upgradePlan.subTitle)}</p>
          </div>
          <div className={styles.plans}>
            <div className={styles.plan}>
              <p className={styles.planType}>{t(texts.upgradePlan.single)}</p>
              <p className={styles.planName}>1 {t(texts.upgradePlan.cameraLicence)}</p>
              <p className={styles.planPrice}>
                {/* <span>{currencySymbol.icon}{oneCamera?.price || '219'}</span>/mo */}
                <span>{currencySymbol.icon}{'219'}</span>/mo
              </p>
              <Button
                title={t(texts.upgradePlan.select)}
                onClick={() => {
                  dispatch(setBillingType('Monthly'));
                  dispatch(setCurrentStripePrice(stripePricesMonthly[0]));
                  history.push({
                  pathname: 'plan',
                  state: {
                    totalCameras: "1 camera",
                    type: 'Monthly'
                  }
                })}
              }
              />
            </div>
            <div className={styles.plan}>
              <p className={styles.planType}>{t(texts.upgradePlan.multiple)}</p>
              <p className={styles.planName}>2-5 {t(texts.upgradePlan.cameraLicences)}</p>
              <p className={styles.planPrice}>
                {/* <span>{currencySymbol.icon}{twoCameras?.price || '199'}</span>/mo */}
                <span>{currencySymbol.icon}{'199'}</span>/mo
              </p>
              <Button
                title={t(texts.upgradePlan.select)}
                onClick={() => {
                dispatch(setBillingType('Monthly'));
                dispatch(setCurrentStripePrice(stripePricesMonthly[1]));
                  history.push({
                  pathname: 'plan',
                  state: {
                    totalCameras: "2 cameras",
                    type: 'Monthly'
                  }
                })}
              }
              />
            </div>
            {/* {
              userInfo.country[0].short_name.toLowerCase() === 'au' && (
                <div className={styles.plan} style={{backgroundColor: '#3EC8AE'}}>
                  <p className={styles.planType} style={{color: '#fff'}}>{t(texts.upgradePlan.PPC)}</p>
                  <p className={styles.planName} style={{color: '#fff', marginTop: 10}}>1-5 {t(texts.upgradePlan.cameraLicences)}</p>
                  <p className={styles.planPrice} style={{color: '#fff'}}>
                    <span>{currencySymbol}{ppcPrice?.price || '50'}</span>/mo + $5  {t(texts.upgradePlan.perAnalysis)}
                  </p>
                  <Button
                    title={t(texts.upgradePlan.select)}
                    bgColor='#fff'
                    onClick={() => history.push({
                      pathname: 'plan',
                      state: {
                        totalCameras: "1 camera",
                        type: 'ppc'
                      }
                    })}
                  />
                </div>
              )
            } */}
          </div>
        </div>
      <div className={styles.footer}>
        <p className={styles.footerText} style={{margin: 0}}>
          {currencySymbol.name === 'aud' && t(texts.upgradePlan.allPricesInAUD)}
          {currencySymbol.name === 'usd' && t(texts.upgradePlan.allPricesInUS)}
          {currencySymbol.name === 'eur' && t(texts.upgradePlan.allPricesInEUR)}
          {currencySymbol.name === 'gbp' && t(texts.upgradePlan.allPricesInGBP)}
        </p>
        <p className={styles.footerText} style={{margin: '10px 0 36px'}}>
          {t(texts.upgradePlan.termsText)}
          <a href={privatePolicyLink} target='_blank' className={styles.footerLink}>
            {t(texts.upgradePlan.privatePolicy)}
          </a>
          &nbsp;
          {t(texts.upgradePlan.and)}
          &nbsp;
          <a href={termsCondition} target='_blank' className={styles.footerLink}>
            {t(texts.upgradePlan.termsCondition)}
          </a>
        </p>
      </div>
    </div>
  );
};
